import slugify from '@sindresorhus/slugify';
import makeUrl from '../../lib/makeUrl';
import sortBy from 'lodash/sortBy';
import { categories, dayCardOrder } from '../../constants/trekDayConstants';

export const makeUrlForLodgeCard = ({
  dayDate,
  cardData,
  patchInfo,
  placeName,
  isAdded,
}) => {
  const lodgeFromDay = Boolean(dayDate);
  const lodgeFromPlace = !lodgeFromDay; /// if no date in day, redirect as place url
  const modifiedName = slugify(cardData.name);
  if (lodgeFromPlace) {
    return makeUrl.goToLodgeFromPlace(modifiedName, cardData.id, placeName);
  } else if (lodgeFromDay) {
    return makeUrl.goToLodgeFromDay({
      dayDate,
      lodgeName: modifiedName,
      lodgeId: cardData.id,
      placeName,
      trekId: patchInfo.trekId,
      dayNo: patchInfo.dayNo,
      segmentId: patchInfo.segmentId,
      isAdded,
    });
  }
};

export const orderedArray = posters =>
  sortBy(posters, [
    function(item) {
      return dayCardOrder.indexOf(item.poster_type);
    },
    function(item) {
      return categories.indexOf(item.categories && item.categories[0]);
    },
  ]);

export const arrayForModal = sortedArray =>
  sortedArray.filter(
    card =>
      card.poster_type === 'attractions' ||
      card.poster_type === 'sightings' ||
      card.poster_type === 'sidetrips'
  );



// WEBPACK FOOTER //
// ./src/screens/Trek/utils.js